import { FC } from "react";
import { useTranslation } from "react-i18next";

import { PageClientSideFilters, PageHeader } from "@ryde/layout";
import { IRydePage } from "@ryde/shared";

import {
  ApiVersionPanel,
  ClearCachePanel,
  CookiesMovePanel,
  GenerateErrorPanel,
  PhoneLinkTestPanel,
  SessionExpirationPanel,
} from "./parts";

export interface IControlsPageProps extends IRydePage {
  addInfo?: string;
}

export const ControlsPage: FC<IControlsPageProps> = () => {
  const { t } = useTranslation();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const displayPanels = {
    framer: false,
    muiControls: false,
    rideControls: true,
  };

  const isCookiesPanelShown = window.location.hash?.includes(
    "show_cookies_dev_panel=1",
  );

  const supportCenterPhone = "+972000000";

  return (
    <>
      <PageHeader mainTitle={t("general.CONTROLS")}>
        <PageClientSideFilters />
      </PageHeader>
      <ApiVersionPanel />
      <SessionExpirationPanel />
      <ClearCachePanel />
      {isCookiesPanelShown && <CookiesMovePanel />}

      <GenerateErrorPanel />
      <PhoneLinkTestPanel phoneNumber={supportCenterPhone} />
      {/* {displayPanels.framer && <FramerTestPanel />}
      {displayPanels.muiControls && <ButtonsTestPanel />}
      {displayPanels.rideControls && <RideControlsTestPanel />} */}
    </>
  );
};
